const CMP_PRESETS = {
  TRANSCEND: 'transcend',
  ONETRUST: 'oneTrust',
};

export default CMP_PRESETS;

export const CMP_PRESET_LABELS = {
  [CMP_PRESETS.TRANSCEND]: 'Transcend',
  [CMP_PRESETS.ONETRUST]: 'OneTrust',
};

export const CMP_PRESET_OPTIONS = [
  { text: 'Transcend (airgap)', value: CMP_PRESETS.TRANSCEND },
  { text: 'OneTrust', value: CMP_PRESETS.ONETRUST },
];
